import {Form} from "@/models/gessan/form";
import {PaginationTableSaneamento} from "@/store/modules/gessan/states/table";
import {Lista} from "@/models/gessan/lista";
export default {
  ["SET_FORM"](state: any, value: Form): void {
    state.form = value;
  },
  ["SET_TABLE_CONTENT"](state: any, value: Lista[]): void {
    state.table.content = value?.map(v=>(
      {
        id: v.id,
        mesAno: v.mesAno,
        qtdeUnAbastecimentoAgua: v.qtdeUnAbastecimentoAgua,
        qtdeUnEsgotamentoSanitario: v.qtdeUnEsgotamentoSanitario,
        faturamentoMensalLiquido: v.faturamentoMensalLiquido,
        quantidadeLigacoesAtivasAguaCapital: v.quantidadeLigacoesAtivasAguaCapital,
        quantidadeLigacoesAtivasAguaInterior: v.quantidadeLigacoesAtivasAguaInterior,
        quantidadeLigacoesAtivasEsgotoCapital: v.quantidadeLigacoesAtivasEsgotoCapital,
        quantidadeLigacoesAtivasEsgotoInterior: v.quantidadeLigacoesAtivasEsgotoInterior,
        faturamentoLiquidoAguaCapital: v.faturamentoLiquidoAguaCapital,
        faturamentoLiquidoAguaInterior: v.faturamentoLiquidoAguaInterior,
        faturamentoLiquidoEsgotoCapital: v.faturamentoLiquidoEsgotoCapital,
        faturamentoLiquidoEsgotoInterior: v.faturamentoLiquidoEsgotoInterior,
        situacao: v.situacao,
        municipio: v.municipio,
        grupoMunicipio: v.grupoMunicipio,
        motivo: v.motivo,
        situacaoDae: v.situacaoDae,
        dae: v.dae,
        dataVencimentoDae: v.dataVencimentoDae,
        memoriaCalculo: v.memoriaCalculo
      }));
  },
  ["SET_TABLE_LOADING"](state: any, value: Boolean): void {
    state.table.isLoading = value;
  },
  ["SET_TABLE_TOTALS"](state: any, value: Number): void {
    state.table.total = value;
  },
  ["SET_TABLE_PAGINATION"](state: any, value: PaginationTableSaneamento): void {
    state.table.paginate = value;
  },
  ["CLEAR_TABLE"](state: any): void {
    state.table.paginate = {
      mesAno: null,
      qtdeUnAbastecimentoAgua: null,
      qtdeUnEsgotamentoSanitario: null,
      faturamentoMensalLiquido: null,
      municipio: null,
      situacao: null,
      situacaoDae: null,
      page: 0,
      size: 10,
      totalElements: null,
      cnpj: null,
    };
  },
}
